import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BubbleService {
  public bubbleData = new Subject<any>();
  public bubbleLoader = new Subject<any>();
  public serviceNetworkData: any;
  
  constructor(
    private http: HttpClient
  ) { }

  setBubbleTreeData() {
    this.bubbleData.next();
  }

  getBubbleTreeData(): Observable<any> {
    return this.bubbleData.asObservable();
  }

  setserviceNetworkData(serviceNetworkData: any) {
    this.serviceNetworkData = serviceNetworkData;
  }

  getserviceNetworkData() {
    return this.serviceNetworkData;
  }

  setBubbleLoader(message: boolean) {
    this.bubbleLoader.next(message);
  }

}
